import { doLogout } from "actions/authAction";
import {
  BASE_URL,
  SHIPPER_URL,
  SHIPPER_GET_ERROR,
  SHIPPER_GET_LOADING,
  SHIPPER_GET_SUCCESS,
  SHIPPER_VIEW_ERROR,
  SHIPPER_VIEW_LOADING,
  SHIPPER_VIEW_SUCCESS,
  SHIPPER_ADD_ERROR,
  SHIPPER_ADD_LOADING,
  SHIPPER_ADD_INVALID,
  SHIPPER_ADD_SUCCESS,
  SHIPPER_DELETE_ERROR,
  SHIPPER_DELETE_LOADING,
  SHIPPER_DELETE_SUCCESS,
  BOOKING_LIST_SHIPPER_EXTERNAL_PO_URL,
  USER_UPDATE_SHIPPER_URL,
  SHIPPER_UPDATE_USER_ERROR,
  SHIPPER_UPDATE_USER_LOADING,
  SHIPPER_UPDATE_USER_SUCCESS,
} from "./constant";

const shipperGetError = (bool) => {
  return {
    type: SHIPPER_GET_ERROR,
    shipperGetError: bool,
  };
};

const shipperGetLoading = (bool) => {
  return {
    type: SHIPPER_GET_LOADING,
    shipperGetLoading: bool,
  };
};

export const shipperGetSuccess = (bool, shippers) => {
  return {
    type: SHIPPER_GET_SUCCESS,
    shipperGetSuccess: bool,
    shippers,
  };
};

const shipperViewError = (bool) => {
  return {
    type: SHIPPER_VIEW_ERROR,
    shipperViewError: bool,
  };
};

const shipperViewLoading = (bool) => {
  return {
    type: SHIPPER_VIEW_LOADING,
    shipperViewLoading: bool,
  };
};

const shipperViewSuccess = (bool, shipper) => {
  return {
    type: SHIPPER_VIEW_SUCCESS,
    shipperViewSuccess: bool,
    shipper,
  };
};

const shipperAddError = (bool) => {
  return {
    type: SHIPPER_ADD_ERROR,
    shipperAddError: bool,
  };
};

const shipperAddLoading = (bool) => {
  return {
    type: SHIPPER_ADD_LOADING,
    shipperAddLoading: bool,
  };
};

const shipperAddInvalid = (bool, invalid) => {
  return {
    type: SHIPPER_ADD_INVALID,
    shipperAddInvalid: bool,
    invalid,
  };
};

const shipperAddSuccess = (bool, shipper) => {
  return {
    type: SHIPPER_ADD_SUCCESS,
    shipperAddSuccess: bool,
    shipper,
  };
};

const shipperUpdateUserError = (bool) => {
  return {
    type: SHIPPER_UPDATE_USER_ERROR,
    shipperUpdateUserError: bool,
  };
};

const shipperUpdateUserLoading = (bool) => {
  return {
    type: SHIPPER_UPDATE_USER_LOADING,
    shipperUpdateUserLoading: bool,
  };
};

const shipperUpdateUserSuccess = (bool, shipperUpdateUser) => {
  return {
    type: SHIPPER_UPDATE_USER_SUCCESS,
    shipperUpdateUserSuccess: bool,
    shipperUpdateUser,
  };
};

const shipperDeleteError = (bool) => {
  return {
    type: SHIPPER_DELETE_ERROR,
    shipperDeleteError: bool,
  };
};

const shipperDeleteLoading = (bool) => {
  return {
    type: SHIPPER_DELETE_LOADING,
    shipperDeleteLoading: bool,
  };
};

const shipperDeleteSuccess = (bool, shipper) => {
  return {
    type: SHIPPER_DELETE_SUCCESS,
    shipperDeleteSuccess: bool,
    shipper,
  };
};

export function shipperUpdateProfile(data) {
  return (dispatch) => {
    dispatch(shipperUpdateUserError(false));
    dispatch(shipperUpdateUserSuccess(false, null));
    dispatch(shipperUpdateUserLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};

    if (token) {
      config = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };
    } else {
      throw Error("Authentication error");
    }
    fetch(BASE_URL + USER_UPDATE_SHIPPER_URL, config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(shipperUpdateUserLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((shipper) => {
        dispatch(shipperUpdateUserSuccess(true, shipper));
      })
      .catch((err) => {
        dispatch(shipperUpdateUserError(true));
      });
  };
}

export function shipperFetchAll() {
  return (dispatch) => {
    dispatch(shipperGetSuccess(false, null));
    dispatch(shipperGetError(false));
    dispatch(shipperGetLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};
    if (token) {
      config = {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      };
    } else {
      throw Error("Authentication error");
    }
    fetch(BASE_URL + SHIPPER_URL, config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(shipperGetLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        dispatch(shipperGetSuccess(true, data));
      })
      .catch((err) => {
        dispatch(shipperGetError(true));
      });
  };
}

export function shipperFetchSub(shipper_id) {
  return (dispatch) => {
    dispatch(shipperGetSuccess(false, null));
    dispatch(shipperGetError(false));
    dispatch(shipperGetLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};
    if (token) {
      config = {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      };
    } else {
      throw Error("Authentication error");
    }
    fetch(BASE_URL + SHIPPER_URL + "/" + shipper_id, config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(shipperGetLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        dispatch(shipperGetSuccess(true, data));
      })
      .catch((err) => {
        dispatch(shipperGetError(true));
      });
  };
}

export function shipperFetchPage(item) {
  return (dispatch) => {
    dispatch(shipperGetSuccess(false, null));
    dispatch(shipperGetError(false));
    dispatch(shipperGetLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};
    if (token) {
      config = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(item),
      };
    } else {
      throw Error("Authentication error");
    }
    fetch(BASE_URL + SHIPPER_URL + "/page", config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(shipperGetLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        dispatch(shipperGetSuccess(true, data));
      })
      .catch((err) => {
        dispatch(shipperGetError(true));
      });
  };
}

export function shipperClear() {
  return (dispatch) => {
    dispatch(shipperGetSuccess(false, null));
    dispatch(shipperGetError(false));
    dispatch(shipperGetLoading(true));
  };
}
export function shipperClears() {
  return (dispatch) => {
    dispatch(shipperGetSuccess(true, { data: [] }));
    dispatch(shipperGetError(false));
    dispatch(shipperGetLoading(false));
  };
}
export function shipperPriceFetchAll(item, tokenx) {
  return (dispatch) => {
    dispatch(shipperGetSuccess(false, null));
    dispatch(shipperGetError(false));
    dispatch(shipperGetLoading(true));

    let token = tokenx || localStorage.getItem("tolaut@token") || null;
    let config = {};
    if (token) {
      config = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(item),
      };
    } else {
      throw Error("Authentication error");
    }
    fetch(BASE_URL + SHIPPER_URL + "/get_biaya_pengurusan", config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        // dispatch(shipperGetLoading(false))
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        dispatch(shipperGetLoading(false));
        dispatch(shipperGetSuccess(true, data));
      })
      .catch((err) => {
        dispatch(shipperGetError(true));
        dispatch(shipperGetLoading(false));
      });
  };
}

export function shipperExternalPOAll(item, tokenx) {
  return (dispatch) => {
    dispatch(shipperGetSuccess(false, null));
    dispatch(shipperGetError(false));
    dispatch(shipperGetLoading(true));

    let token = tokenx || localStorage.getItem("tolaut@token") || null;
    let config = {};
    if (token) {
      config = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(item),
      };
    } else {
      throw Error("Authentication error");
    }
    fetch(BASE_URL + BOOKING_LIST_SHIPPER_EXTERNAL_PO_URL, config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        // dispatch(shipperGetLoading(false))
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        dispatch(shipperGetLoading(false));
        dispatch(shipperGetSuccess(true, data));
      })
      .catch((err) => {
        dispatch(shipperGetError(true));
        dispatch(shipperGetLoading(false));
      });
  };
}

export function shipperAdd(data) {
  return (dispatch) => {
    dispatch(shipperAddError(false));
    dispatch(shipperAddSuccess(false, null));
    dispatch(shipperAddInvalid(false, null));
    dispatch(shipperAddLoading(true));

    let config = {};
    let formData = new FormData();
    for (var key in data) {
      formData.append(key, data[key]);
    }
    config = {
      method: "POST",
      body: formData,
    };
    fetch(BASE_URL + SHIPPER_URL + "/new", config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(shipperAddLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((shipper) => {
        if (shipper.success) {
          dispatch(shipperAddSuccess(true, shipper));
        } else {
          window.alert(shipper.message);
          dispatch(shipperAddInvalid(true, shipper));
        }
      })
      .catch((err) => {
        dispatch(shipperAddError(true));
        dispatch(shipperAddLoading(false));
      });
  };
}

export function shipperUpdate(data) {
  return (dispatch) => {
    dispatch(shipperAddError(false));
    dispatch(shipperAddSuccess(false, null));
    dispatch(shipperAddLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};
    let formData = new FormData();
    for (var key in data) {
      formData.append(key, data[key]);
    }
    if (token) {
      config = {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      };
    } else {
      throw Error("Authentication error");
    }
    fetch(BASE_URL + SHIPPER_URL, config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(shipperAddLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((shipper) => {
        if (shipper.status === 400) {
          window.alert(shipper.message);
        } else {
          window.alert(shipper.message);
          dispatch(shipperAddSuccess(true, shipper));
        }
      })
      .catch((err) => {
        dispatch(shipperAddError(true));
      });
  };
}
// export function shipperUpdateProfile(data) {
//   return (dispatch) => {
//     dispatch(shipperAddError(false));
//     dispatch(shipperAddSuccess(false, null));
//     dispatch(shipperAddLoading(true));

//     let token = localStorage.getItem("tolaut@token") || null;
//     let config = {};
//     let formData = new FormData();
//     for (var key in data) {
//       formData.append(key, data[key]);
//     }
//     if (token) {
//       config = {
//         method: "PUT",
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//         body: formData,
//       };
//     } else {
//       throw Error("Authentication error");
//     }
//     fetch(BASE_URL + "users/update_shipper_doc", config)
//       .then((response) => {
//         if (response.status === 401) {
//           dispatch(doLogout());
//         }
//         if (!response.ok) {
//           throw Error(response.statusText);
//         }
//         dispatch(shipperAddLoading(false));
//         return response;
//       })
//       .then((response) => response.json())
//       .then((shipper) => {
//         dispatch(shipperAddSuccess(true, shipper));
//       })
//       .catch((err) => {
//         dispatch(shipperAddError(true));
//       });
//   };
// }

export function shipperConfirm(data) {
  return (dispatch) => {
    dispatch(shipperAddError(false));
    dispatch(shipperAddSuccess(false, null));
    dispatch(shipperAddLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};
    if (token) {
      config = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };
    } else {
      throw Error("Authentication error");
    }
    fetch(BASE_URL + SHIPPER_URL + "/approve", config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(shipperAddLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((shipper) => {
        if (shipper.status === "200 OK") {
          dispatch(shipperAddSuccess(true, shipper));
        } else {
          dispatch(shipperAddError(true));
        }
      })
      .catch((err) => {
        dispatch(shipperAddError(true));
      });
  };
}

export function shipperFetchOne(id) {
  return (dispatch) => {
    dispatch(shipperViewError(false));
    dispatch(shipperViewSuccess(false, null));
    dispatch(shipperViewLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};
    if (token) {
      config = {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      };
    } else {
      throw Error("Authentication error");
    }
    fetch(BASE_URL + SHIPPER_URL + "/" + id, config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(shipperViewLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        dispatch(shipperViewSuccess(true, data));
      })
      .catch((err) => {
        dispatch(shipperViewError(true));
      });
  };
}

export function shipperFetchUser(id) {
  return (dispatch) => {
    dispatch(shipperViewError(false));
    dispatch(shipperViewSuccess(false, null));
    dispatch(shipperViewLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};
    if (token) {
      config = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id: id }),
      };
    } else {
      throw Error("Authentication error");
    }
    fetch(BASE_URL + SHIPPER_URL + "/profile", config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(shipperViewLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        dispatch(shipperViewSuccess(true, data));
      })
      .catch((err) => {
        dispatch(shipperViewError(true));
      });
  };
}

export function handleStatus(data) {
  return (dispatch) => {
    dispatch(shipperAddError(false));
    dispatch(shipperAddSuccess(false, null));
    dispatch(shipperAddLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};

    if (token) {
      config = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };
    } else {
      throw Error("Authentication error");
    }
    fetch(BASE_URL + "register/" + data.status, config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(shipperAddLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((shipper) => {
        if (shipper.status === 200) {
          dispatch(shipperAddSuccess(true, shipper));
        } else {
          alert(shipper.message);
        }
      })
      .catch((err) => {
        dispatch(shipperAddError(true));
      });
  };
}

export function handleStatusAktif(data) {
  return (dispatch) => {
    dispatch(shipperAddError(false));
    dispatch(shipperAddSuccess(false, null));
    dispatch(shipperAddLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};

    if (token) {
      config = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };
    } else {
      throw Error("Authentication error");
    }
    fetch(BASE_URL + "register/is_active", config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(shipperAddLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((shipper) => {
        if (shipper.status === 200) {
          dispatch(shipperAddSuccess(true, shipper));
        } else {
          alert(shipper.message);
        }
      })
      .catch((err) => {
        dispatch(shipperAddError(true));
      });
  };
}

export function shipperDelete(id) {
  return (dispatch) => {
    dispatch(shipperViewSuccess(false, null));
    dispatch(shipperDeleteError(false));
    dispatch(shipperDeleteSuccess(false, null));
    dispatch(shipperDeleteLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};
    if (token) {
      config = {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id: id }),
      };
    } else {
      throw Error("Authentication error");
    }
    fetch(BASE_URL + SHIPPER_URL, config)
      .then((response) => {
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(shipperDeleteLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        dispatch(shipperDeleteSuccess(true, data));
      })
      .catch((err) => {
        dispatch(shipperDeleteError(true));
      });
  };
}
